import { useState, useContext } from "react";
import { UserContext } from "../../../../contexts/userProvider";
import { PatrimonioContext } from "../../../../contexts/patrimonioProvider";
import BaseInput from "../../../General/FormsComp/Input/BaseInput";
import BaseButton from "../../../General/FormsComp/Button/BaseButton";

const Cadastro = (props) => {
  const { user } = useContext(UserContext);
  const { criarMarca } = useContext(PatrimonioContext);
  const [novaMarca, setNovaMarca] = useState({
    nome: "",
    id_fornecedor: props.fornecedor.id,
    id_usuario: user.id,
    usuario: user.nome,
  });

  const handleInput = (e) => {
    const { value, name } = e.target;
    setNovaMarca({ ...novaMarca, [name]: value });
  };

  const handleCreateMarca = async () => {
    let newMarca = { ...novaMarca };
    newMarca.created_at = newMarca.updated_at = new Date().toISOString().slice(0, 19).replace('T', ' ');
    let success = await criarMarca(newMarca);
    if(success){
      props.setCadastroModal(false);
      props.receberMarcas()
    }
  }

  return (
    <div className="visualizar-modal">
      <div className="visualizar-modal-body">
        <div className="patrimonio-modal-header">
          <h1>Cadastro de Marca</h1>
          <h1>Nome do Fornecedor : {props.fornecedor.nome}</h1>
        </div>
        <div className="visualizar-modal-content">
          <div className="patrimonio-modal-content-inputs">
            <BaseInput
              label="Nome"
              name="nome"
              value={novaMarca.nome}
              onChange={handleInput}
              type="text"
              required
            />
          </div>
        </div>
        <div className="patrimonio-modal-footer">
          <BaseButton
            variant="ghost"
            onClick={(e) => props.setCadastroModal(false)}
          >
            Fechar
          </BaseButton>
          <BaseButton
            variant="primary"
            onClick={handleCreateMarca}
          >
            Salvar
          </BaseButton>
        </div>
      </div>
    </div>
  );
};

export default Cadastro;
